import { render, staticRenderFns } from "./DPlayer.vue?vue&type=template&id=8291b678"
import script from "./DPlayer.vue?vue&type=script&lang=js"
export * from "./DPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports